export type TButtonType = "default" | "gray" | "red" | "yellow" | "pink" | "cyan" | "orange" | "blue" | "success";
export type TButtonSize = "small" | "regular" | "large";
export type TButtonRadius = "r-12" | "r-24";
